var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightSwipeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 93"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 13.5,
    cy: 13.5,
    r: 11.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9993 13.9906C17.9938 13.7482 17.901 13.5166 17.7389 13.3405L12.0257 7.2218C11.8499 7.03508 11.6093 6.92763 11.3565 6.92301C11.1038 6.91838 10.8596 7.01697 10.6775 7.19714C10.4954 7.37732 10.3901 7.6244 10.3849 7.88421C10.3796 8.14402 10.4748 8.39538 10.6495 8.58318L15.7304 14.0212L10.6495 19.4591C10.4748 19.6469 10.3796 19.8983 10.3849 20.1581C10.3901 20.4179 10.4954 20.665 10.6775 20.8452C10.8596 21.0254 11.1038 21.1239 11.3565 21.1193C11.6093 21.1147 11.8499 21.0072 12.0257 20.8205L17.7389 14.7019C17.8262 14.6071 17.8943 14.4954 17.939 14.3732C17.9837 14.2511 18.0042 14.121 17.9993 13.9906Z",
    fill: "#0081DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSwipeIcon);
export default __webpack_public_path__ + "static/media/rightSwipeIcon.26530437712b5cd79659e8a051dff8a7.svg";
export { ForwardRef as ReactComponent };